/* @flow */
import { dispatcher } from 'lib/Dispatcher';
import { PushEvents } from 'pusher/PusherConstants';
import PusherClient from './PusherClient';

const PusherActions = {
  subscribeToChannel(channelName: string) {
    if (PusherClient.isSubscribedTo(channelName)) {
      return;
    }

    // Have all pusher event go through the dispatcher
    PusherClient.subscribe(channelName).then(channel => {
      channel.bind_all((event, data) => {
        dispatcher.handlePusherEvent({
          type: event,
          eventData: data,
        });
      });
    }).catch(e => console.error('PusherActions subscribeToChannel failed', e));

    PusherClient.bind('state_change', this.updateConnectionState);
  },

  unsubscribeToChannel(channelName: string) {
    PusherClient.unsubscribe(channelName);
  },

  updateConnectionState(states: {previous: mixed, current: mixed}) {
    dispatcher.handlePusherEvent({
      type: PushEvents.CONNECTION_STATE_CHANGED,
      previous: states.previous,
      current: states.current,
    });
  },

  retryConnection() {
    PusherClient.retry();
    dispatcher.handlePusherEvent({
      type: PushEvents.RETRY_CONNECTION,
    });
  },

  resetStore() {
    dispatcher.handlePusherEvent({
      type: PushEvents.RESET_STORE,
    });
  },
};

export default PusherActions;



// WEBPACK FOOTER //
// ./src/pusher/PusherActions.js